<div
  class="mt-big fs-14"
  [innerHTML]="content()"
></div>
